module.exports = __webpack_public_path__ + "img/duanwu_ps_04.f8ec9a5a.jpg";